// extracted by mini-css-extract-plugin
module.exports = {"table":"FieldsTable_table__3OsBY","tableHeadCell":"FieldsTable_tableHeadCell__2IICp"};